var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20603d",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fad201",
    d: "M.3 0h53.4v30H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a1de",
    d: "M.3 0h53.4v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5be01",
    d: "m49.4 10.5-4.5.2 4.2 1.4-4.3-.9 3.7 2.5-4-2 3 3.3-3.4-3 2 4-2.4-3.7.9 4.4-1.4-4.3-.3 4.5v-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5be01",
    d: "m49.4 10.5-4.5-.3 4.2-1.4-4.3.9 3.7-2.5-4 2 3-3.3-3.4 3 2-4-2.4 3.7.9-4.4-1.4 4.3-.3-4.5v6.5zm-12.9 0 4.4.2-4.2 1.4 4.4-.9-3.8 2.5 4-2-3 3.3 3.4-3-2 4 2.5-3.7-1 4.4 1.5-4.3.2 4.5v-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5be01",
    d: "m36.5 10.5 4.4-.3-4.2-1.4 4.4.9-3.8-2.5 4 2-3-3.3 3.4 3-2-4 2.5 3.7-1-4.4 1.5 4.3.2-4.5v6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5be01",
    stroke: "#00a1de",
    strokeWidth: 0.3,
    d: "M43 12.4a2 2 0 1 0 0-3.9 2 2 0 0 0 0 3.9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/rw.c0d3708a48c21da42090e0430706ae54.svg";
export { ForwardRef as ReactComponent };